import {Provider} from "@angular/core";
import {Logger} from "../../../core/interfaces/Logger";
import {CashHardwareAdapter} from "../adapters/cash-hardware.adapter";
import {CalendarEventAdapter} from "../../calendar-event/adapters/calendar-event.adapter";
import {SocketService} from "../../../core/services/socket/socket.service";
import {DeviceAdapter} from "../../../core/entities/device/infrastructure/adapters/device.adapter";
import {ServicesService} from "../../../core/entities/service/services.service";
import {SocketRoomHandlerService} from "src/app/core/services/socket/socket-room-handler.service";
import {GlobalSplashArtLoaderService} from "../../services/global-splashart-loader/global-splashart-loader.service";
import {FeatureFlagAdapter} from "../adapters/feature-flag.adapter";
import {ConfirmationService} from "../../presentation/services/confirmation.service";
import {AccountModeService} from "../../../core/entities/account/account-modes/account-mode.service";
import {DEVICE} from "../../domain/tokens/device.token";
import {LOGGER_SERVICE} from "../../domain/tokens/logger.token";
import {EVENT_BUS} from "../../domain/tokens/event-bus.token";
import {CASH_HARDWARE} from "../../domain/tokens/cash-hardware.token";
import {CALENDAR_EVENT_SERVICE} from "../../calendar-event/token/calendar-event.token";
import {SPLASH_LOADER} from "../../domain/tokens/splash-loader.token";
import {SERVICE_CONFIG} from "../../domain/tokens/service-config.token";
import {SOCKET_SERVICE} from "../../domain/tokens/socket-service.token";
import {FEATURE_FLAG_SERVICE} from "../../domain/tokens/feature-flag.token";
import {SOCKET_ROOM_HANDLER} from "../../domain/tokens/socket-room-handler.token";
import {CONFIRMATION_SERVICE} from "../../domain/tokens/confirmation-service.token";
import {ACCOUNT_MODE_SERVICE} from "../../domain/tokens/account-mode-service.token";
import {CAPACITOR_SERVICE} from "../../capacitor-service/token/capacitor-service.token";
import {
  OrganizationRepositoryAdapter
} from "../../../core/entities/organization/infrastructure/adapters/organization-repository.adapter";
import {ORGANIZATION_SERVICE} from "../../../core/entities/organization/domain/token/organization.token";
import {CapacitorServiceAdapter} from "../../capacitor-service/adapters/capacitor.service";
import {SERVICE_STATE_SERVICE} from "../../../features/service/domain/tokens/service-state.token";
import {ServiceStateService} from "../../../features/service/application/services/service-state.service";
import {EventBusPort} from "@platform/event-bus/domain/ports/event-bus.port";

export const SHARED_PROVIDERS: Provider[] = [
  {
    provide: EVENT_BUS,
    useExisting: EventBusPort
  },
  {
    provide: SPLASH_LOADER,
    useExisting: GlobalSplashArtLoaderService
  },
  {
    provide: DEVICE,
    useClass: DeviceAdapter
  },
  {
    provide: CASH_HARDWARE,
    useClass: CashHardwareAdapter
  },
  {
    provide: CONFIRMATION_SERVICE,
    useClass: ConfirmationService
  },
  {
    provide: SOCKET_SERVICE,
    useExisting: SocketService
  },
  {
    provide: SERVICE_CONFIG,
    useExisting: ServicesService
  },
  {
    provide: SOCKET_ROOM_HANDLER,
    useExisting: SocketRoomHandlerService
  },
  {
    provide: LOGGER_SERVICE,
    useExisting: Logger
  },
  {
    provide: FEATURE_FLAG_SERVICE,
    useClass: FeatureFlagAdapter
  },
  {
    provide: ACCOUNT_MODE_SERVICE,
    useExisting: AccountModeService
  },
  {
    provide: CALENDAR_EVENT_SERVICE,
    useClass: CalendarEventAdapter
  },
  {
    provide: CAPACITOR_SERVICE,
    useClass: CapacitorServiceAdapter
  },
  {
    provide: ORGANIZATION_SERVICE,
    useClass: OrganizationRepositoryAdapter
  },
  {
    provide: SERVICE_STATE_SERVICE,
    useClass: ServiceStateService
  },
];
